import { ClientWebsiteConfig } from "../Config";
import { Logger, LogLevel } from "../Logger";
import { ServiceType, ServiceManager, IOnDemandService } from "../ServiceManager";
import { BrowserStorageService, IBrowserStorageProvider } from "../BrowserStorageService";
import { FormValue } from '../../types/Forms';

class AutosaveManager implements IOnDemandService {
    Type: ServiceType = ServiceType.FormAutosave;
    Id: string = 'AutosaveManager';

    Namespace: string;
    StorageInterface: IBrowserStorageProvider;

    constructor(config: ClientWebsiteConfig, namespace?: string, storageProvider?: IBrowserStorageProvider) {
        this.Namespace = namespace || config.Id;

        this.StorageInterface = storageProvider || ServiceManager.Require<BrowserStorageService>(ServiceType.BrowserStorage);
    }

    GetState(form: string): FormValue[] | null {
        var item = this.StorageInterface.getItem(`PROLIST.Autosave.${this.Namespace}.${form}`);

        if(item == null) return null;

        var data: FormValue[] | null = null;
        try {
            data = JSON.parse(item);
        } catch (ex) {
            Logger.Log(LogLevel.Error, 'Failed to parse data for form ' + form, ex);
        }

        return data;
    }

    SetState(form: string, data: FormValue[]) {
        this.StorageInterface.setItem(`PROLIST.Autosave.${this.Namespace}.${form}`, JSON.stringify({
            data: data,
            date: new Date()
        }));
    }
}

export { AutosaveManager }
